import { Injectable } from '@angular/core';
import * as msal from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

// Servicio encargado unicamente de conseguir el access token de Sharepoint (scope
// https://sites.ey.com/.default) que el backend (SharepointController) necesita para
// autenticarse contra la REST API de Sharepoint en nuestro nombre. El resto de la
// operativa de Sharepoint (leer/crear/borrar carpetas y archivos, etc.) vive en el
// backend; este servicio solo se encarga de la parte de autenticacion en el front.
@Injectable({
    providedIn: 'root'
})
export class SharepointAuthService {
    private msalInstance: msal.PublicClientApplication;
    private initPromise: Promise<void> | null = null;
    // Comparte una única llamada en curso entre peticiones concurrentes para no
    // disparar varias negociaciones silenciosas de MSAL en paralelo.
    private pendingTokenRequest: Promise<string | null> | null = null;

    constructor() {
        const msalConfig = {
            auth: {
                clientId: environment.clientID,
                authority: `https://login.microsoftonline.com/${environment.tenantID}`,
                redirectUri: environment.redirectUrl,
            }
        };

        this.msalInstance = new msal.PublicClientApplication(msalConfig);
    }

    // Consigue el access token de Sharepoint que hay que pasarle al backend en cada llamada.
    getAccessToken(): Promise<string | null> {
        if (!this.pendingTokenRequest) {
            this.pendingTokenRequest = this.acquireAccessToken().finally(() => {
                this.pendingTokenRequest = null;
            });
        }

        return this.pendingTokenRequest;
    }

    private async acquireAccessToken(): Promise<string | null> {
        try {
            if (environment.envType === 'production' || environment.envType === 'development' || environment.envType === 'preproduction') {
                if (!this.initPromise) {
                    this.initPromise = this.msalInstance.initialize();
                }
                await this.initPromise;
                const response = await this.msalInstance.acquireTokenSilent({ scopes: ["https://sites.ey.com/.default"] });
                return response.accessToken;
            }

            return environment.sharepointDevToken || null;
        } catch {
            return null;
        }
    }
}
